import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  SetSafetyAnswerMutation,
  SetSafetyAnswerMutationVariables
} from './__generated__/SetSafetyAnswerMutation'

const mutation: TypedDocumentNode<
  SetSafetyAnswerMutation,
  SetSafetyAnswerMutationVariables
> = gql`
  mutation SetSafetyAnswerMutation($input: SetSafetyAnswerInput!) {
    setSafetyAnswer(input: $input) {
      clientMutationId
    }
  }
`

export function setSafetyAnswerMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      SetSafetyAnswerMutation,
      SetSafetyAnswerMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
